import { FilterConfig, ProductListConfig } from "@b2b/ui-components";
import { Search } from "lucide-react";

export interface ContentItem {
  id: string;
  title: string;
  type: "Banner" | "Blog" | "Product Guide" | "Faq";
  status: "draft" | "published";
  lastUpdated: string;
  author: string;
}

export const contentTableConfig: ProductListConfig = {
  columns: [
    { key: "title", label: "Title", align: "left" as const },
    { key: "type", label: "Type", align: "center" as const },
    { key: "status", label: "Status", align: "center" as const },
    { key: "lastUpdated", label: "Last Updated", align: "center" as const },
    { key: "author", label: "Author", align: "center" as const },
  ],
  styles: {
    headerBg: "bg-gray-50",
    headerText: "text-gray-700",
    rowHover: "hover:bg-gray-50",
    statusStyles: {
      published: {
        background: "bg-green-100",
        textColor: "text-green-700",
      },
      draft: {
        background: "bg-yellow-100",
        textColor: "text-yellow-700",
      },
    },
  },
};

export const contentItems: ContentItem[] = [
  {
    id: "1",
    title: "Welcome to Our B2B Marketplace",
    type: "Banner",
    status: "published",
    lastUpdated: "2024-01-15",
    author: "Admin",
  },
  {
    id: "2",
    title: "How to Source Products Effectively",
    type: "Blog",
    status: "published",
    lastUpdated: "2024-01-14",
    author: "Content Team",
  },
  {
    id: "3",
    title: "Supplier Verification Process",
    type: "Product Guide",
    status: "draft",
    lastUpdated: "2024-01-13",
    author: "Marketing",
  },
  {
    id: "4",
    title: "Payment Methods & Security",
    type: "Faq",
    status: "published",
    lastUpdated: "2024-01-12",
    author: "Support",
  },
  {
    id: "5",
    title: "Spring Sale 2024 Banner",
    type: "Banner",
    status: "draft",
    lastUpdated: "2024-01-11",
    author: "Marketing",
  },
];
